import SalesTabManagerComponent from './SalesTabManager';
import LaborTabManagerComponent from './LaborTabManager';
import InventoryControlTabManagerComponent from './InventoryControlTabManager';
import ServicesTabManagerComponent from './ServicesTabManager';
import OmniTabManagerComponent from './OmniTabManager';

const SalesTabManager = SalesTabManagerComponent;
const LaborTabManager = LaborTabManagerComponent;
const InventoryControlTabManager = InventoryControlTabManagerComponent;
const ServicesTabManager = ServicesTabManagerComponent;
const OmniTabManager = OmniTabManagerComponent;

export {
  SalesTabManager,
  LaborTabManager,
  InventoryControlTabManager,
  ServicesTabManager,
  OmniTabManager,
};
